<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
  >
    <path d="M4.5 5L4.5 9C4.5 9.27614 4.72386 9.5 5 9.5C5.27614 9.5 5.5 9.27614 5.5 9L5.5 5C5.5 4.72386 5.27614 4.5 5 4.5C4.72386 4.5 4.5 4.72386 4.5 5ZM7 4.5C7.27614 4.5 7.5 4.72386 7.5 5V9C7.5 9.27614 7.27614 9.5 7 9.5C6.72386 9.5 6.5 9.27614 6.5 9V5C6.5 4.72386 6.72386 4.5 7 4.5ZM8 2H11C11.2761 2 11.5 2.22386 11.5 2.5C11.5 2.77614 11.2761 3 11 3H10.4475L9.69462 9.77608C9.55394 11.0422 8.48378 12 7.20991 12H4.79008C3.51621 12 2.44605 11.0422 2.30537 9.77608L1.55247 3H1C0.723858 3 0.5 2.77614 0.5 2.5C0.5 2.22386 0.723858 2 1 2H4C4 0.89543 4.89543 0 6 0C7.10457 0 8 0.895431 8 2ZM6 1C5.44772 1 5 1.44772 5 2H7C7 1.44772 6.55229 1 6 1ZM2.55863 3L3.29925 9.66565C3.38366 10.4253 4.02575 11 4.79008 11H7.20991C7.97423 11 8.61633 10.4253 8.70073 9.66565L9.44136 3H2.55863Z" />
  </svg>
</template>
